import { Skeleton } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';

/** Price / about / documents placeholders under the unit image + title. */
export function PropertyDetailsBelowFoldShimmer() {
  const colors = useUIColors();
  return (
    <>
      <Skeleton
        width="100%"
        height={90}
        borderRadius={16}
        baseColor={colors.backgroundLevel3}
        highlightColor={colors.backgroundLevel4}
      />
      <Skeleton
        width="100%"
        height={180}
        borderRadius={12}
        baseColor={colors.backgroundLevel3}
        highlightColor={colors.backgroundLevel4}
      />
      <Skeleton
        width="100%"
        height={80}
        borderRadius={12}
        baseColor={colors.backgroundLevel3}
        highlightColor={colors.backgroundLevel4}
      />
    </>
  );
}
